<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  [paginated]="false"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
></app-data-grid>
